document.addEventListener("click", function(e)
{
  var target = e.target;

  if(target.tagName !== "BUTTON" && !(target.dataset && target.dataset.modal))
    return;

  if(target.dataset == null || target.dataset.modal == null)
    return;

  const modal = document.querySelector(target.dataset.modal);

  modal.classList.remove("k-modal--active");
});

window.hideModal = function(id)
{
    document.querySelector(id).classList.remove("k-modal--active");
}

window.showModal = function(id)
{
    var modals = document.querySelectorAll(".k-modal");

    [...modals].forEach((i) =>
    {
        i.classList.remove("k-modal--active");
    });

    document.querySelector(id).classList.add("k-modal--active");
}